import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-wood-dark text-cream relative overflow-hidden wood-texture" data-id="element-160">
      <div className="absolute inset-0 bg-wood-dark/80 mix-blend-multiply" data-id="element-161"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto border-4 border-amber rounded-3xl p-8 md:p-16 text-center bg-wood-dark/50 backdrop-blur-sm" data-id="element-163">
          <ShieldCheck className="w-24 h-24 text-amber mx-auto mb-8" data-id="element-164" />

          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-165">
            GARANTÍA SUPER COMBO™ — 7 DÍAS
          </h2>

          <p className="text-xl md:text-2xl text-cream-dark/90 mb-8 font-medium" data-id="element-166">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu taller si
            querés.
          </p>

          <div className="bg-amber/20 py-6 px-4 rounded-xl mb-8 border border-amber/30" data-id="element-167">
            <p className="text-2xl md:text-3xl font-bold text-amber-light" data-id="element-168">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-169" />
              Te devolvemos el 100%.
            </p>
          </div>

          <p className="text-lg text-cream/80 mb-6" data-id="element-170">
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <p className="text-cream/70 italic max-w-2xl mx-auto" data-id="element-171">
            La confianza que tenemos en el Super Combo Carpintería Plegable
            PRO™ nos permite hacer esa promesa sin dudar. Más de 500
            carpinteros de todo el país ya lo saben. La tasa de devoluciones es
            menor al 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}